export default [
  {
    path: '/app/project-services',
    name: 'ProjectServices',
    component: () => import('@/views/Admin/Project_services/Index.vue'),
    meta: {
      pageTitle: 'Proje Hizmetleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECT_SERVICES_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/project-services/add',
    name: 'ProjectServicesAdd',
    component: () => import('@/views/Admin/Project_services/Add.vue'),
    meta: {
      pageTitle: 'Proje Hizmetleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/project-services',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECT_SERVICES_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/project-services/edit/:id',
    name: 'ProjectServicesEdit',
    component: () => import('@/views/Admin/Project_services/Edit.vue'),
    meta: {
      pageTitle: 'Proje Hizmetleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/project-services',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECT_SERVICES_EDIT',
      action: 'read',
    },
  },
]
